<template>
  <div>
    <div class="Mb10 print_cash">견적 금액 합계: <span class="result_price">{{totalPrice | numberFormat}}원</span>  (부가세 포함)  </div>
    
    <table cellspacing="0" border="0" summary="견적 내용" class="estimate_table2">
      <colgroup data-v-25b96154=""><col data-v-25b96154="" width="4%"> <col data-v-25b96154="" width="8%"> <col data-v-25b96154="" width="15%"> <col data-v-25b96154="" width="5%"> <col data-v-25b96154="" width="5%"> <col data-v-25b96154="" width="5%"> <col data-v-25b96154="" width="10%"> <col data-v-25b96154="" width="10%"> <col data-v-25b96154="" width="10%"> <col data-v-25b96154="" width="15%"></colgroup>
      <thead>
      <tr>
        <th class="first">번호</th>
        <th>서비스</th>
        <th>상품</th>
        <th>상세</th>
        <th>수량</th>
        <th>이용 기간</th>
        <th>정가</th>
        <th>공급가액</th>
        <th>세액</th>
        <th>비고</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(rowInfo, index) in rowList" :key="index">

        <td :rowspan="rowList.length" class="first" v-if="index<=0">   {{index+1}}   </td>
        <td :rowspan="rowList.length" v-if="index<=0">   하이웍스   </td>

        <td class="L">   {{rowInfo.name}}   </td>
        <td><span>    {{rowInfo.detail ? rowInfo.detail : '-'}}  </span></td>
        <td>
          <span v-if="rowInfo.quantity">{{rowInfo.quantity}}개</span>
          <span v-else>-</span>
        </td>
        <td>
          <span v-if="rowInfo.term">{{rowInfo.term}}</span>
          <span v-else>-</span>
        </td>
        <td class="R word_break">   {{rowInfo.originPrice | numberFormat}}원   </td>
        <td class="R word_break">   {{rowInfo.price | numberFormat}}원   </td>
        <td class="R word_break">   {{rowInfo.vat | numberFormat}}원   </td>
        <td>
          <span v-if="!rowInfo.note">   -   </span>
          <span v-else>   {{rowInfo.note}}   </span>
        </td>
      </tr>
      <tr class="total">
        <td colspan="6" class="first">총합</td>
        <td>{{totalInfo.originPrice | numberFormat}}원</td>
        <td>{{totalInfo.price | numberFormat}}원</td>
        <td>{{totalInfo.vat | numberFormat}}원</td>
        <td>{{totalInfo.totalPrice | numberFormat}}원</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: "EstimateDetail",
  computed: {
    ...mapGetters({
      totalPrice : 'order_info/getTotalPrice',
      mainGoodsOrderList : 'order_info/getOrderInfoList',
      subGoodsOrderList : 'order_info/getSubGoodsOrderInfoList',
    }),
    totalInfo(){
      let totalInfo = {
        originPrice : 0,
        price : 0,
        vat : 0,
        totalPrice : 0,
      }
      
      this.rowList.forEach(rowInfo => {
        totalInfo.originPrice += parseInt(rowInfo.originPrice)
        totalInfo.price += parseInt(rowInfo.price)
        totalInfo.vat += parseInt(rowInfo.vat)
        totalInfo.totalPrice += parseInt(rowInfo.price) + parseInt(rowInfo.vat) 
      })
      
      return totalInfo
    },
    rowList(){
      let rowList = []

      this.mainGoodsOrderList.forEach(mainGoodsOrderInfo => {
        // 1. main_goods 추가 
        let mainGoodsRowInfo = this.getRowFormat()
        
        mainGoodsRowInfo.id = mainGoodsOrderInfo.id
        mainGoodsRowInfo.name = mainGoodsOrderInfo.goodsName
        mainGoodsRowInfo.quantity = mainGoodsOrderInfo.quantity
        mainGoodsRowInfo.term = mainGoodsOrderInfo.term + "개월"
        mainGoodsRowInfo.originPrice = mainGoodsOrderInfo.priceInfo.origin_price
        mainGoodsRowInfo.price = mainGoodsOrderInfo.priceInfo.price
        mainGoodsRowInfo.vat = mainGoodsOrderInfo.priceInfo.price * 0.1

        // 1.1. 할인 정보가 있을 경우 비고 정보 추가
        if(mainGoodsOrderInfo.discount && mainGoodsOrderInfo.discount.length > 0){
          let disCountInfo = mainGoodsOrderInfo.discount[0]
          if(disCountInfo.sub_price > 0){
            let disCountText = "[" + disCountInfo.rule_name + " " + disCountInfo.display_value + "] -" 
                + this.$options.filters.numberFormat(disCountInfo.sub_price) + "원"
            mainGoodsRowInfo.note = disCountText
          }
        }
        
        rowList.push(mainGoodsRowInfo)


        // 2. 설치비 추가
        if(mainGoodsOrderInfo.priceInfo.installation_cost){
          let installationCostRowInfo = this.getRowFormat()
          installationCostRowInfo.id = mainGoodsOrderInfo.id
          installationCostRowInfo.name = " ㄴ 설치비"
          installationCostRowInfo.quantity = null
          installationCostRowInfo.term = null
          installationCostRowInfo.originPrice = mainGoodsOrderInfo.priceInfo.installation_cost.origin_price
          installationCostRowInfo.price = mainGoodsOrderInfo.priceInfo.installation_cost.price
          installationCostRowInfo.vat = installationCostRowInfo.price * 0.1
          
          // 2.1 설치비의 할인 정책이 있을경우 반영
          if(mainGoodsOrderInfo.priceInfo.installation_cost.discount_rule){
            mainGoodsOrderInfo.priceInfo.installation_cost.discount_rule.forEach(installationDiscountInfo => {
              if(installationDiscountInfo.sub_price){
                installationCostRowInfo.price = installationCostRowInfo.price - parseInt(installationDiscountInfo.sub_price)
              }
              installationCostRowInfo.vat = installationCostRowInfo.price * 0.1
              installationCostRowInfo.note = "["+installationDiscountInfo.rule_name+" "+installationDiscountInfo.display_value
                  +"] "+this.$options.filters.numberFormat(installationDiscountInfo.sub_price)+"원"
            console.log(installationCostRowInfo, installationDiscountInfo)
            })
          }

          rowList.push(installationCostRowInfo)
        }
      })
      
      
      // 3. sub_goods 추가
      this.subGoodsOrderList.forEach(subGoodsOrderInfo => {
        let subGoodsRowInfo = this.getRowFormat()

        subGoodsRowInfo.id = subGoodsOrderInfo.id
        subGoodsRowInfo.name = subGoodsOrderInfo.name
        subGoodsRowInfo.originPrice = subGoodsOrderInfo.priceInfo.origin_price * subGoodsOrderInfo.quantity ?? 1
        subGoodsRowInfo.price = subGoodsOrderInfo.priceInfo.price * subGoodsOrderInfo.quantity ?? 1
        subGoodsRowInfo.vat = subGoodsOrderInfo.priceInfo.price * 0.1 * subGoodsOrderInfo.quantity ?? 1
        
        // term_unit이 time일 경우 기간이 아니기때문에 1회로 변경
        // time이 아닐경우 priceInfo.term_volume 그대로 사용
        if(subGoodsOrderInfo.term_unit==="time"){
          subGoodsRowInfo.term = "1회"
        } else{
          subGoodsRowInfo.term = subGoodsOrderInfo.priceInfo.term_volume + "개월"
        }

        // 3.2 sub_goods의 상세는 pervolume이 있을경우 그냥 subGoodsOrderInfo.volume / subGoodsOrderInfo.perVolume
        // 없을경우 subGoodsOrderInfo.volume
        // 다만 예외적으로 volumeUnit이 ea일 경우 detail을 표시하지 않는다.
        if(subGoodsOrderInfo.perVolume){
          subGoodsRowInfo.detail = subGoodsOrderInfo.perVolume + subGoodsOrderInfo.volumeUnit
        } else{
          if(subGoodsOrderInfo.volumeUnit !== 'ea'){
            subGoodsRowInfo.detail = this.$options.filters.numberFormat(subGoodsOrderInfo.volume)  + subGoodsOrderInfo.volumeUnit
          }
        }

        // 3.2 sub_goods의 수량은 pervolume가 있을경우 그냥 quantity
        // 없을경우 (subGoodsOrderInfo.volume / subGoodsOrderInfo.perVolume) * subGoodsOrderInfo.quantity
        if(subGoodsOrderInfo.perVolume){
          subGoodsRowInfo.quantity = (subGoodsOrderInfo.volume / subGoodsOrderInfo.perVolume) * subGoodsOrderInfo.quantity
        } else{
          subGoodsRowInfo.quantity = subGoodsOrderInfo.quantity
        }

        // 3.1. 할인 정보가 있을 경우 비고 정보 추가
        if(subGoodsOrderInfo.priceInfo.discount_rule && subGoodsOrderInfo.priceInfo.discount_rule.length > 0){
          let disCountInfo = subGoodsOrderInfo.priceInfo.discount_rule[0]
          if(disCountInfo.sub_price > 0){
            let disCountText = "[" + disCountInfo.rule_name + " " + disCountInfo.display_value + "] -"
                + this.$options.filters.numberFormat(disCountInfo.sub_price * subGoodsOrderInfo.quantity ?? 1) + "원"
            subGoodsRowInfo.note = disCountText
          }
        }
        
        rowList.push(subGoodsRowInfo)
      })
      
      return rowList
    },
  },
  methods: {
    getRowFormat(){
      return {
        id : null,
        name : null,
        detail : null,
        quantity : null,
        term : null,
        originPrice : null,
        price : null,
        vat : null,
        note : null,
      }
    }
  }
}
</script>

<style scoped>

</style>